import PropTypes from 'prop-types';

import { Abstrap } from '..';

const propTypes = { ...Abstrap.propTypes, size: PropTypes.oneOf(['xxs', 'xs', 's', 'm', 'l', 'xl', 'full']) };

const defaultProps = {
    ...Abstrap.defaultProps,
    componentClass: 'img',
    size: null,
};

class Image extends Abstrap {

    getClassNameSchema() {
        const {
            className,
            size,
        } = this.props;
        return [
            'c-image',
            size ? `c-image--${size}` : '',
            className,
        ];
    }

    renderChildren() {
        return undefined;
    }

}

Image.propTypes = propTypes;

Image.defaultProps = defaultProps;

export default Image;
